export var unknownLoadErrorAnalyticsPayload = {
  smartLinkActionType: 'StatusUpdate',
  reason: 'UnknownError',
  step: 'load'
};
export var permissionLoadErrorAnalyticsPayload = {
  smartLinkActionType: 'StatusUpdate',
  reason: 'PermissionError',
  step: 'load'
};
export var unknownUpdateErrorAnalyticsPayload = {
  smartLinkActionType: 'StatusUpdate',
  reason: 'UnknownError',
  step: 'update'
};
export var validationUpdateErrorAnalyticsPayload = {
  smartLinkActionType: 'StatusUpdate',
  reason: 'ValidationError',
  step: 'update'
};